// Global variables
export var frame_info = {
  'total_frames': 101,
  'num_thumbnails': -1,
  'num_subframes': -1,
  'curr': 0,
  'thumbnail_number': 0,
  'canvas-w': 0,
  'min_frame': 0,
  'max_frame': -1,
  'is_playing': false
}

export var frame_option = {
  'benign': {
    'background': 'frame', // ['frame', 'confidence'] 
    'skeleton': {
      'onoff': 'on', // ['on', 'off']
      'color': 'importance', // ['off', 'importance']
      'size': 'importance', // ['off', 'importance']
      'label': 'on'
    }
  },
  'attacked': {
    'background': 'frame', // ['frame', 'perturbation', 'confidence'] 
    'skeleton': {
      'onoff': 'on', // ['on', 'off']
      'color': 'importance', // ['off', 'importance']
      'size': 'importance', // ['off', 'importance']
      'label': 'on'
    }
  }
}

export var selected_keypoints = []

export var plot_value = {

  'selected': {
    // 'benign_softmax_weightlifting': true, 
    // 'attacked_softmax_weightlifting': true
    'benign_avg_delta': true,
    'attacked_avg_delta': true
  },
  'all': [
    // 'benign_softmax_weightlifting', 
    // 'attacked_softmax_weightlifting'
    'benign_avg_delta',
    'attacked_avg_delta'
  ],
  'color': {
    // 'benign_softmax_weightlifting': '#33BB33',
    // 'attacked_softmax_weightlifting': '#FF8800'
    'benign_avg_delta': '#33BB33',
    'attacked_avg_delta': '#FF8800'
  }
}

export var separate_view_skeleton = {
  'frame': 'one' // ['one', 'range']
}

export var skeleton_data = {
  'benign': {},
  'attacked': {}
}